import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const CricketIcon = observer('CricketIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            className={className}
            onClick={onClick}
        >
            <mask
                id='cricketMask'
                width='14'
                height='14'
                x='1'
                y='1'
                maskUnits='userSpaceOnUse'
                style={{ maskType: 'alpha' }}
            >
                <path
                    fill='#142448'
                    d='m10 9.567-1.867 1.866a.64.64 0 0 1-.466.2.64.64 0 0 1-.467-.2L1.533 5.767a.62.62 0 0 1-.2-.45q0-.25.2-.45L3.4 3a.66.66 0 0 1 .483-.2q.284 0 .484.2L10 8.633a.64.64 0 0 1 .2.467.64.64 0 0 1-.2.467m2.4 5.2-2.833-2.834L10.5 11l2.833 2.833zM12.333 6.1a2.25 2.25 0 0 1-1.65-.683A2.25 2.25 0 0 1 10 3.767q0-.967.683-1.65a2.25 2.25 0 0 1 1.65-.684q.967 0 1.65.684.684.683.684 1.65t-.684 1.65a2.25 2.25 0 0 1-1.65.683'
                />
            </mask>
            <g mask='url(#cricketMask)'>
                <path
                    fill='#0b1627'
                    fillOpacity='.64'
                    d='M0 0h16v16H0z'
                />
            </g>
        </SvgElement>
    );
});
